import { Field } from "formik";
import { useMemo } from "react";
import { Form as BForm, Card, Col, Row } from "react-bootstrap";
import TextInput from "../../../../../components/formfields/InputField";
import CustomPicker from "../FreebiesSection/CustomPicker";
import UploadVideo from "../HeroSection/UploadVideo";

type SectionPropTypes = {
  section: string;
  values: any;
  props?: any;
  handleChange: any;
  handleBlur: any;
  setFieldValue: any;
  sectionEdit: boolean;
  setVideoUploading: any;
};

const Section = ({ section, props, values, handleChange, handleBlur, setFieldValue, sectionEdit, setVideoUploading }: SectionPropTypes) => {
  const count = useMemo(() => {
    if (section === "section_one") return "1";
    if (section === "section_two") return "2";
    return "3";
  }, [section]);

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h6 className="mb-0 fs-lg }">{`Section ${count}`}</h6>
      </Card.Header>
      <Card.Body>
        <Row className="gy-3">
          <Col lg="6">
            <BForm.Label>Title</BForm.Label>
            <Field
              name={`${section}.title`}
              component={TextInput}
              value={values[section as keyof typeof values]?.title}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Title"
              readOnly={!sectionEdit}
              className={sectionEdit ? "editField" : ""}
            />
          </Col>
          <Col lg="6">
            <CustomPicker setFieldValue={setFieldValue} name={`${section}.color`} value={values[`${section}`].color} label="Hover Color" edit={sectionEdit} />
          </Col>
          <Col xs={12}>
            <label className="form-label">Description</label>
            <Field
              name={`${section}.description`}
              component={TextInput}
              value={values[section as keyof typeof values]?.description}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Description"
              readOnly={!sectionEdit}
              className={sectionEdit ? "editField" : ""}
              multiline
            />
          </Col>
          <Col xs={12}>
            <label className="form-label">Animated Text</label>
            <Field
              name={`${section}.animatedText[0]`}
              component={TextInput}
              value={values[section as keyof typeof values]?.animatedText[0]}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Line 1"
              readOnly={!sectionEdit}
              className={sectionEdit ? "editField" : ""}
            />
            <Field
              name={`${section}.animatedText[1]`}
              component={TextInput}
              value={values[section as keyof typeof values]?.animatedText[1]}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Line 2"
              readOnly={!sectionEdit}
              className={sectionEdit ? "editField" : ""}
            />
            <Field
              name={`${section}.animatedText[2]`}
              component={TextInput}
              value={values[section as keyof typeof values]?.animatedText[2]}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Line 3"
              readOnly={!sectionEdit}
              className={sectionEdit ? "editField" : ""}
            />
            <Field
              name={`${section}.animatedText[3]`}
              component={TextInput}
              value={values[section as keyof typeof values]?.animatedText[3]}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Line 4"
              readOnly={!sectionEdit}
              className={sectionEdit ? "editField" : ""}
            />
            <Field
              name={`${section}.animatedText[4]`}
              component={TextInput}
              value={values[section as keyof typeof values]?.animatedText[4]}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Line 5"
              readOnly={!sectionEdit}
              className={sectionEdit ? "editField" : ""}
            />
          </Col>
          <Col xs="12">
            <label className={`form-label mb-0 ${!sectionEdit ? "edit" : ""}`} htmlFor="image">
              Upload Videos
            </label>
            <UploadVideo
              key={`${section}.video`}
              name={`${section}.video`}
              value={values[`${section}`].video}
              setFieldValue={setFieldValue}
              edit={sectionEdit}
              uploadAction={props.uploadFileAction}
              setVideoUploading={setVideoUploading}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Section;
